<template>
  <b-modal
    :id="id"
    ref="bModalC"
    size="xs"
    modal-class="modal-confirmation-checkable"
    ok-variant="-primary btn-sm"
    cancel-variant="-primary btn__outline btn-sm"
    centered
    :title="$t('component.modalConfirmation.title')"
    :ok-title="$t('component.modalConfirmation.okTitle')"
    :cancel-title="$t('component.modalConfirmation.cancelTitle')"
    @ok="()=> {onOk(), $emit('ok')}"
    @cancel="() => {onCancel(), $emit('cancel')}"
    @hide="onHide"
  >
    <div class="py-1 px-2 confirmation-text">
      <div class="mb-2">
        {{ content }}
      </div>
      <b-form-checkbox
        v-model="status"
        :value="true"
        :unchecked-value="false"
      >
        {{ checkable }}
      </b-form-checkbox>
    </div>
  </b-modal>
</template>

<script>
import customConfigResource from '@/api/resources/ui/CustomConfigResource'

export default {
    name: 'ModalConfirmationCheckable',
    props: {
        id: { type: String, required: true },
        content: { type: String, default: function() { return this.$tc('component.modalConfirmation.content') } },
        checkable: { type: String, default: function() { return this.$tc('component.modalConfirmation.dontShowAgain') } },
        uiComponent: { type: String },
        name: { type: String },
        storeName: { type: String }
    },
    data() {
        return {
            status: false,
            onOk: () => {},
            onCancel: () => {}
        }
    },
    methods: {
        async show(onOk, onCancel) {
            this.onOk = onOk || (() => {})
            this.onCancel = onCancel || (() => {})
            this.$refs.bModalC.show()
        },
        async onHide() {
            this.onOk = function() {
            }
            if (this.storeName && this.name) {
                const modalsState = this.$store.getters.modalsState[this.storeName] ?? {}
                modalsState[this.name] = this.status
                await this.$_setModalConfirmationState(this.storeName, modalsState)

                if (this.status && this.uiComponent) {
                    await customConfigResource.save(this.uiComponent, modalsState)
                }
            }
        }
    }
}

</script>

<style lang="scss">
.modal-confirmation-checkable .modal-body {
    height: auto !important;
}
.modal-confirmation-checkable .confirmation-text {
    color: vt-color(dark-text);
}
.modal-confirmation-checkable .modal-footer .btn {
    width: 80px;
}
</style>
